import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ComponentBase, DialogData, SelectCreateComponentStyle } from '@definitiv-packages/angular-dba-library';
import { ProjectLanguage } from '../../types/ProjectLanguage';
import { ObjektModelView } from '../../types/ObjektModel';
import { RoofareaModel, RoofareaModelView } from '../../types/RoofareaModel';
import { ObjektViewService } from '../../services/Views/ObjektModelView.service';
import { RoofareaService } from '../../services/Models/RoofareaModel.service';
import { SysLandService } from '../../services/Models/SysLandModel.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ProjektPermissionService } from '../../services/projektpermission.service';
import { DebitorModelView, DebitorViewService, StandortModelView, StandortViewService } from '../../../public-api';
import { CreateStandortComponent } from '../create-standort/create-standort.component';

@Component({
  selector: 'app-create-roofarea',
  templateUrl: './create-roofarea.component.html',
  styleUrls: ['./create-roofarea.component.scss'],
  standalone: false
})
export class CreateRoofareaComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public roofarea: RoofareaModel | null = null;
  public debitorList: DebitorModelView[] = [];
  public standortList: StandortModelView[] = [];
  public selectedstandortModelView : StandortModelView| null=null;
  public objektList: ObjektModelView[] = [];
  public isMobile: boolean = false;
  private DebitorControl : FormControl<DebitorModelView|null> = new FormControl<DebitorModelView|null>(null, [Validators.required ]);
  private StandortControl: FormControl<StandortModelView | null> = new FormControl<StandortModelView | null>(null, [Validators.required ]);
  
  private ObjektControl: FormControl<ObjektModelView | null> = new FormControl<ObjektModelView | null>(null, [Validators.required]);
  private BezeichnungControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(100)]);
  
  public FormGroup = new UntypedFormGroup({
    debitorControl: this.DebitorControl,
    standortControl: this.StandortControl,
    objektControl: this.ObjektControl,
    bezeichnungControl: this.BezeichnungControl,
  });

  public styleList: SelectCreateComponentStyle<ObjektModelView>[] = [
    { selectName: 'DebitorNummer', cssClass: 'alignleft' },
    { selectName: 'DebitorName', cssClass: 'alignleft' },
    { selectName: 'Bezeichnung', cssClass: 'alignleft' },
    { selectName: 'PLZ', cssClass: 'alignleft' },
    { selectName: 'Ort', cssClass: 'alignleft' },
    { selectName: 'LandName', cssClass: 'alignleft' },
  ];

  //#endregion

  constructor(
    public dialogRef: MatDialogRef<CreateRoofareaComponent>,
    public debitorService: DebitorViewService,
    public standortViewService: StandortViewService,
    public objektService: ObjektViewService,
    public roofareaService: RoofareaService,
    public syslandService: SysLandService,
    public deviceService        : DeviceDetectorService,
    public permissionService: ProjektPermissionService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<RoofareaModelView>
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;

    this.isMobile = this.deviceService.getDeviceInfo().deviceType != "desktop";
    this.debitorList= await this.debitorService.getList(),
    this.standortList= await this.standortViewService.getList(),
    this.objektList = await this.objektService.getList();
    


    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.roofareaerstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.roofareabearbeiten);
    }

    if(!this.data.data?.RoofareaID && this.data.data?.DebitorID){
        this.debitorList = this.debitorList.filter(x=>x.DebitorID == this.data.data?.DebitorID)
    }
    if(!this.data.data?.RoofareaID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID == this.data.data?.StandortID)
    }
    if(!this.data.data?.RoofareaID && this.data.data?.ObjektID){
        this.objektList = this.objektList.filter(x=>x.ObjektID == this.data.data?.ObjektID)
    }

    if (this.data.data?.RoofareaID) {

      this.roofarea = await this.roofareaService.get(this.data.data.RoofareaID);
      this.BezeichnungControl.setValue(this.roofarea.Bezeichnung);

      if (this.roofarea.ObjektID)
        this.ObjektControl.setValue(this.objektList.find(x => x.ObjektID == this.roofarea?.ObjektID)!);
    }
    else {
      this.roofarea = {} as RoofareaModel;
      if(!this.data.data?.RoofareaID && this.data.data?.StandortID){
        this.standortList = this.standortList.filter(x=>x.StandortID==this.data.data?.StandortID)
        this.StandortControl.setValue(this.standortList[0]) ;
      }
      if(!this.data.data?.RoofareaID && this.data.data?.ObjektID){
        this.objektList = this.objektList.filter(x=>x.ObjektID==this.data.data?.ObjektID)
        this.ObjektControl.setValue(this.objektList[0]) ;
      }
    }
    this.loading = false;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (!this.FormGroup.valid) return;

    try {
      this.loading = true;
      this.roofarea = new RoofareaModel();

      if (this.data.mode == 'edit' && this.data.data)
        this.roofarea.RoofareaID = this.data.data?.RoofareaID!;

      this.roofarea.Bezeichnung = this.BezeichnungControl.value!;
      this.roofarea.Longitude = 0;
      this.roofarea.Latitude  = 0;

      if (this.ObjektControl.value)
        this.roofarea.ObjektID = this.ObjektControl.value?.ObjektID!;

      if (this.roofarea.RoofareaID > 0)       //Update
        var Item = await this.roofareaService.put(this.roofarea.RoofareaID, this.roofarea)
      else                                  // Insert
        var Item = await this.roofareaService.post(this.roofarea)

      this.loading = false;
      this.dialogRef.close(Item);
    } finally {
      this.loading = false;
    }
  }

  public openMaps(): void {
    /*
    var adress = this.LatitudeControl.value + ", " + this.LongitudeControl.value
    const url = "https://www.google.com/maps/search/" + adress;
    window.open(url, '_blank');
    */
  }

  public formatLongitude(): void {
 /*   const ctrl = this.FormGroup.get('longitudeControl');
    if (ctrl?.value !== null) {
      ctrl?.setValue(Number(ctrl.value).toFixed(10), { emitEvent: false });
    }
      */
  }

  public formatLatitude(): void {
    /*
    const ctrl = this.FormGroup.get('latitudeControl');
    if (ctrl?.value !== null) {
      ctrl?.setValue(Number(ctrl.value).toFixed(10), { emitEvent: false });
    }
      */
  }

  getfilterStandortList(){
        if(!this.DebitorControl.value?.DebitorID) return[];
        return this.standortList.filter(x=>x.DebitorID == this.DebitorControl.value?.DebitorID);
    }
    public OpenCreateStandortDialog=():Promise<StandortModelView>=>{
        return new Promise<StandortModelView>((resolve, reject) => {
    
          var StandortModelView : StandortModelView={
              StandortID:  0,
              DebitorID:this.DebitorControl.value?.DebitorID!,
              Strasse :"",
              PLZ:"",
              Ort:"",
              LandID:null,
              Bezeichnung : ""
          }
          
          var data = new DialogData(StandortModelView, 'create');
          this.dialog.open(CreateStandortComponent, { data: data }).afterClosed().subscribe((item: StandortModelView) => {
            if(item){
                this.standortList.push(item);
            }
            
            resolve(item);
          });
          
        });    
    } 
}
